/* eslint-disable @typescript-eslint/no-var-requires */
import countries from 'i18n-iso-countries'
import { find, get, keys, lowerCase, map, sortBy, toUpper } from 'lodash'

countries.registerLocale(require('i18n-iso-countries/langs/de.json'))
countries.registerLocale(require('i18n-iso-countries/langs/en.json'))
countries.registerLocale(require('i18n-iso-countries/langs/fr.json'))
countries.registerLocale(require('i18n-iso-countries/langs/it.json'))
countries.registerLocale(require('i18n-iso-countries/langs/nl.json'))
countries.registerLocale(require('i18n-iso-countries/langs/pl.json'))
countries.registerLocale(require('i18n-iso-countries/langs/ru.json'))
countries.registerLocale(require('i18n-iso-countries/langs/tr.json'))
countries.registerLocale(require('i18n-iso-countries/langs/ru.json'))
countries.registerLocale(require('i18n-iso-countries/langs/hr.json'))
countries.registerLocale(require('i18n-iso-countries/langs/es.json'))
countries.registerLocale(require('i18n-iso-countries/langs/pt.json'))
countries.registerLocale(require('i18n-iso-countries/langs/sv.json'))
countries.registerLocale(require('i18n-iso-countries/langs/no.json'))
countries.registerLocale(require('i18n-iso-countries/langs/da.json'))
countries.registerLocale(require('i18n-iso-countries/langs/fi.json'))
countries.registerLocale(require('i18n-iso-countries/langs/el.json'))
countries.registerLocale(require('i18n-iso-countries/langs/hu.json'))
countries.registerLocale(require('i18n-iso-countries/langs/ro.json'))
countries.registerLocale(require('i18n-iso-countries/langs/cs.json'))
countries.registerLocale(require('i18n-iso-countries/langs/sk.json'))
countries.registerLocale(require('i18n-iso-countries/langs/lt.json'))
countries.registerLocale(require('i18n-iso-countries/langs/lv.json'))
countries.registerLocale(require('i18n-iso-countries/langs/et.json'))
countries.registerLocale(require('i18n-iso-countries/langs/bg.json'))
countries.registerLocale(require('i18n-iso-countries/langs/sq.json'))
countries.registerLocale(require('i18n-iso-countries/langs/mk.json'))
countries.registerLocale(require('i18n-iso-countries/langs/sr.json'))
countries.registerLocale(require('i18n-iso-countries/langs/bs.json'))
countries.registerLocale(require('i18n-iso-countries/langs/sl.json'))
countries.registerLocale(require('i18n-iso-countries/langs/ro.json'))
countries.registerLocale(require('i18n-iso-countries/langs/be.json'))
countries.registerLocale(require('i18n-iso-countries/langs/uk.json'))

export const dachList = ['DE', 'AT', 'LI', 'CH']

export const europeList = [
  'FR',
  'IT',
  'BE',
  'BG',
  'CY',
  'CZ',
  'DK',
  'EE',
  'ES',
  'FI',
  'FO',
  'GB',
  'GR',
  'HR',
  'HU',
  'IE',
  'IS',
  'LT',
  'LU',
  'LV',
  'MT',
  'NL',
  'NO',
  'PL',
  'PT',
  'RO',
  'SE',
  'SI',
  'SK',
  'SM',
  'VA',
]

export const euList = [
  'AT',
  'BE',
  'BG',
  'HR',
  'CY',
  'CZ',
  'DK',
  'ES',
  'FI',
  'FR',
  'DE',
  'GR',
  'HU',
  'IR',
  'IT',
  'LT',
  'LU',
  'LV',
  'MT',
  'NL',
  'PL',
  'PT',
  'RO',
  'SI',
  'SK',
  'ES',
  'SE',
]

export const countryList = [
  'DE',
  'AT',
  'CH',
  'LI',
  'FR',
  'IT',
  'BE',
  'BG',
  'CY',
  'CZ',
  'DK',
  'EE',
  'ES',
  'FI',
  'FO',
  'GB',
  'GR',
  'HR',
  'HU',
  'IE',
  'IS',
  'LT',
  'LU',
  'LV',
  'MT',
  'NL',
  'NO',
  'PL',
  'PT',
  'RO',
  'SE',
  'SI',
  'SK',
  'SM',
  'VA',
]

export const countryOptions = map(countryList, (c) => ({
  value: c,
  label: c,
}))

export type TCountryOptionitem = {
  label?: string
  value?: string
}
export const makeOptions = (
  codes: string[],
  language: string,
  useShortCode: boolean,
  hideCountryText: boolean,
): TCountryOptionitem[] => {
  const result = map(codes, (code) => {
    const upperCode = toUpper(code)
    let label: string | undefined =
      countries.getName(upperCode, language) ||
      countries.getName(upperCode, 'en')
    if (useShortCode) {
      label = upperCode
    }
    if (hideCountryText) {
      label = undefined
    }
    return {
      label,
      value: code,
    }
  })
  return sortBy(result, [(o) => o.label || o.value])
}

export function getCountryName(short: string): string | undefined {
  return get(
    find(countryOptions, (o) => o.value === short),
    'label',
  )
}

export const getAllAlpha2Countries = (): string[] =>
  keys(countries.getAlpha2Codes())

export function parseCountry(value: string): TCountryOptionitem | undefined {
  return find(countryOptions, (o) => o.value === value)
}

export function stringifyCountry(
  value: TCountryOptionitem,
): string | undefined {
  return get(value, 'value')
}

export const getIcon = (shortcode: string): string => {
  const value = lowerCase(shortcode)
  switch (value) {
    case 'en':
      return 'gb'
    default:
      return value
  }
}

export const alpha3ToAlpha2 = (shortCode: string): string =>
  countries.alpha3ToAlpha2(shortCode)
